/**
 * A DataGrid lapozó-felirata magyarul („1–15 / 15”). A @mui/x-data-grid
 * huHU fordításából ez hiányzik (angol „1–15 of 15” maradt).
 */
export interface DisplayedRowsArgs {
  from: number;
  to: number;
  count: number;
  estimated?: number;
}

export const huPaginationDisplayedRows = ({ from, to, count, estimated }: DisplayedRowsArgs): string => {
  if (count !== -1) return `${from}–${to} / ${count}`;
  if (estimated && estimated > to) return `${from}–${to} / kb. ${estimated}`;
  return `${from}–${to} / több mint ${to}`;
};
